export enum AUTH_PAGEURLS {
  B2C_SELECT_LOGIN_METHOD = "/auth/login/",
  B2C_LOGIN_EMAIL = "/auth/login/email/",
  B2C_LOGIN_EMAIL_OTP = "/auth/login/email/otp/",
  B2C_LOGIN_PHONE = "/auth/login/phone/",
  B2C_LOGIN_PHONE_OTP = "/auth/login/phone/otp/",
  B2C_REGISTER_EMAIL = "/auth/register/email/",
  B2C_REGISTER_EMAIL_OTP = "/auth/register/email/otp/",
  B2C_REGISTER_PHONE = "/auth/register/",
  B2C_REGISTER_PHONE_OTP = "/auth/register/phone/otp/",
  B2C_REGISTER_ACCOUNT_TYPE = "/auth/register/profileType/",
  B2C_REGISTER_STUDENT_INFO = "/auth/register/student/",
  B2C_REGISTER_STUDENT_PERMISSONS = "/auth/register/student/permissions/",
  B2C_REGISTER_PARENT_INFO = "/auth/register/parent/",
  B2C_REGISTER_PARENT_PERMISSONS = "/auth/register/parent/permissions/",

  B2B_LICENCE_CODE_ENTRY = "/basla/",
  B2B_ONBOARDING_PHONE = "/basla/phone/",
  B2B_ONBOARDING_PHONE_OTP = "/basla/phone/otp/",
  B2B_ONBOARDING_EMAIL = "/basla/email/",
  B2B_ONBOARDING_EMAIL_OTP = "/basla/email/otp/",
  B2B_ONBOARDING_ACCOUNT_TYPE = "/basla/profileType/",
  B2B_ONBOARDING_STUDENT_INFO = "/basla/student/",
  B2B_ONBOARDING_PERMISSONS = "/basla/permissions/",
  B2B_ONBOARDING_SUCCESS = "/basla/success/",
}
